<template>
    <b-form @submit.prevent="getAuditData(formData)">
        <b-form-group :label="$t('audit.dateTime')">
            <b-form-select v-model="dateRangeType" :options="dateRangeTypes" v-on:change="dateRangeTypeSelected"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('general.fromDate')">
            <date-picker v-model="formData.dateTimeStart" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group :label="$t('general.toDate')">
            <date-picker v-model="formData.dateTimeEndForm" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group :label="$t('audit.subject')">
            <b-form-input v-model="formData.subject"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('audit.success')">
            <b-form-select v-model="formData.success" :options="successOptions" />
        </b-form-group>
        <b-form-row class="mx-0">
            <b-button type="submit" variant="success" class="ml-auto" :disabled="isDisabled">
                <magnify-icon title="" />&nbsp;{{ $t('general.search') }}
            </b-button>
        </b-form-row>
    </b-form>
</template>

<script>
/* eslint-disable */

import AppData from '@/utils/appdata'
import * as U from '@/utils/utils';

export default {
    name: 'AuditSearchForm',
    mixins: [ AppData ],
    props: {
        fetch: Function,
        offset: Number,
        pageSize: Number,
        setOffset: Function
    },
    data () {
        return {
            dateRangeType: U.DateRangeType.LastDay,
            formData: {
                dateTimeStart: null,
                dateTimeEndForm: null,
                dateTimeEnd: U.getEndOfCurrentDay(),
                subject: null,
                success: null,
                offset: this.offset,
                pageSize: this.pageSize
            },
            datePickerLocale: this.$store.getters.locale.toLowerCase()
        }
    },
    mounted() {
        this.dateRangeTypeSelected();
    },
    computed: {
        dateRangeTypes() {
            return [
                { value: U.DateRangeType.LastHour, text: this.$t('general.lastHour') },
                { value: U.DateRangeType.Last12Hours, text: this.$t('general.last12Hours') },
                { value: U.DateRangeType.LastDay, text: this.$t('general.lastDay') }
            ];
        },

        successOptions() {
            return [
                {value: null, text: this.$t('general.select')},
                {value: true, text: this.$t('audit.yes')},
                {value: false, text: this.$t('audit.no')},
            ];
        }
    },
    watch: {
        offset(newValue) {
            this.formData.offset = newValue;
            this.fetch(this.formData);
        }
    },
    methods: {
        dateSelected() {
            this.formData.dateTimeStart = this.pickedDateRange[0];
            this.formData.dateTimeEndForm = this.pickedDateRange[1];
        },
        getAuditData(formData) {
            if (this.offset !== 0) {
                this.setOffset(0);
            } else {
                this.fetch(formData);
            }
        },
        dateRangeTypeSelected() {
            const dateRange = U.getDateRange(this.dateRangeType);

            this.formData.dateTimeStart = dateRange.start;
            this.formData.dateTimeEndForm = dateRange.end;
        }
    }
}
</script>
